import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { CheckCircle, XCircle, Loader } from 'lucide-react';
import API from '../api';

const MagicLinkVerify = () => {
    const { t } = useTranslation();
    const { token } = useParams();
    const navigate = useNavigate();
    const [status, setStatus] = useState('verifying'); // verifying, success, error
    const [message, setMessage] = useState('');

    useEffect(() => {
        verifyToken();
    }, [token]);

    const verifyToken = async () => {
        try {
            const res = await API.get(`/auth/magic-link/verify/${token}/`);

            if (res.data.access) {
                localStorage.setItem('token', res.data.access);
                setStatus('success');
                setMessage(t('magic_verify.success_desc'));

                setTimeout(() => {
                    navigate('/');
                }, 2000);
            } else {
                setStatus('error');
                setMessage(t('magic_verify.token_invalid'));
            }
        } catch (err) {
            console.error('Magic link verify error:', err);
            setStatus('error');
            setMessage(err.response?.data?.error || t('magic_verify.default_failed'));
        }
    };

    return (
        <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 flex flex-col justify-center items-center py-12 px-4">
            <div className="bg-white rounded-2xl shadow-xl p-8 max-w-md w-full text-center">
                {status === 'verifying' && (
                    <>
                        <Loader className="w-16 h-16 text-blue-600 animate-spin mx-auto mb-4" />
                        <h2 className="text-xl font-bold text-gray-900 mb-2">{t('magic_verify.verifying')}</h2>
                        <p className="text-gray-600">{t('magic_verify.verifying_desc')}</p>
                    </>
                )}

                {status === 'success' && (
                    <>
                        <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
                            <CheckCircle className="w-10 h-10 text-green-600" />
                        </div>
                        <h2 className="text-xl font-bold text-gray-900 mb-2">{t('magic_verify.success')}</h2>
                        <p className="text-gray-600">{message}</p>
                    </>
                )}

                {status === 'error' && (
                    <>
                        <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-4">
                            <XCircle className="w-10 h-10 text-red-600" />
                        </div>
                        <h2 className="text-xl font-bold text-gray-900 mb-2">{t('magic_verify.failed')}</h2>
                        <p className="text-gray-600 mb-6">{message}</p>
                        <button
                            onClick={() => navigate('/login')}
                            className="px-6 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors"
                        >
                            {t('magic_verify.back_to_login')}
                        </button>
                    </>
                )}
            </div>
        </div>
    );
};

export default MagicLinkVerify;
